import global from "global";
import processSingleElement from "./processSingleElement";

const getElementsToAnimate = ({ newPositions, recordedPositions }) => {
  const { innerHeight: windowHeight } = global;

  const toAnimate = [];

  newPositions.forEach(elementPosition =>
    processSingleElement({
      elementPosition,
      recordedPositions,
      windowHeight,
      toAnimate
    })
  );

  return toAnimate;
};

export default getElementsToAnimate;
